import React, { useEffect, useState, useRef } from 'react';
import { withRouter } from 'react-router';

import { connect } from 'react-redux';

import { Grid, GridColumn as Column, GridNoRecords } from '@progress/kendo-react-grid';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import useWindowSize from '../../../hooks/useWindowSize';
import {calculateMinColumnWidths} from '../../../helpers/calculateMinColumnWidths';

//import BobRuleFilterComponent from '../../../components/BobRuleFilterComponent';
import { dashboardContent } from '../../../localization/en-us/dashboardContent';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';

import { getTimeZoneAbbr } from '../../../helpers/timezones';
import moment from 'moment';

import * as ruleActions from '../../../actions/ruleActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import * as BobActions from '../../../actions/bobActions';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import classes from './Table.module.css';

const RuleDebugger = ({
    activeNavCompany,
    bobLoading,
    endTimestamp,
    fetchRuleDebuggerList,
    rule,
    startTimestamp,
    ruleEndTimeStamp,
    ruleStartTimeStamp,
    history,
    setWorkBookMode,
    workbookModeEnabled,
    ...props
}) => {
    const initialDataState = {
        take:   100,
        skip:   0,
        sort:   [],
        filter: []
    };

    const [ruleDebuggerList, setRuleDebuggerList] = useState([]);
    const [take, setTake] = useState(100);
    const [page, setPage] = useState(1);
    const [skip, setSkip] = useState(0);
    const [pageable] = useState({pageSizes: [50, 100, 250]});
    const [total, setTotal] = useState(0);
    const [dataState, setDataState] = useState(initialDataState);
    const [messageColumnWidth, setMessageColumnWidth] = useState(600);

    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const columns = gridRef.current.props.children;
        setMessageColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'notes', 600, true));
    }, [windowSize]);

    useEffect( () => {
        async function init() {
            let options = {
                startTimestamp: ruleStartTimeStamp.toISOString(),
                endTimestamp:   ruleEndTimeStamp.toISOString(),
                pageSize:       take,
                page:           page
            };

            const payload = await fetchRuleDebuggerList(rule.id, { ...options });

            setTotal(payload.meta.totalCount);
            setRuleDebuggerList(payload.data);
        }
        if (rule && rule.id) init();
    }, [rule, ruleStartTimeStamp, ruleEndTimeStamp]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setDataState(initialDataState);
        }
    }, [workbookModeEnabled]);

    const refreshGrid = () => {
        async function refresh() {
            let options = {
                startTimestamp: ruleStartTimeStamp.toISOString(),
                endTimestamp:   ruleEndTimeStamp.toISOString(),
                pageSize:       take,
                page:           page
            };
            const payload = await fetchRuleDebuggerList(rule.id, {...options});
            setTotal(payload.meta.totalCount);
            setRuleDebuggerList(payload.data);
        }
        if (rule && rule.id) refresh();
    };

    const dateCell = props => {
        const zone = moment.tz.guess();
        const parsedDate = Date.parse(props.dataItem[props.field]);
        const displayDate = isNaN(parsedDate) === false && new Date(props.dataItem[props.field]) < new Date(2099, 11, 31) ? new moment(props.dataItem[props.field]).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(parsedDate, zone) : '';

        return (
            <td className={props.className} style={props.style}>
                {displayDate}
            </td>
        );
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    const onDataStateChange = async e => {
        if (e.dataState.skip !== skip || e.dataState.take !== take) {
            let pageNumber = 1;

            if (e.dataState.skip > 0) {
                pageNumber = e.dataState.skip / e.dataState.take + 1;
                setPage(pageNumber);
            }

            let options = {
                startTimestamp: ruleStartTimeStamp.toISOString(),
                endTimestamp:   ruleEndTimeStamp.toISOString(),
                pageSize:       take,
                page:           pageNumber
            };
            const payload = await fetchRuleDebuggerList(rule.id, {...options});
            setTotal(payload.meta.totalCount);
            setRuleDebuggerList(payload.data);
        }
        setSkip(e.dataState.skip);
        setTake(e.dataState.take);
        setDataState(e.dataState);
    };

    return (
        <div className={classes.RuleDebugger}>
            <div className={classes.RuleNameContainer}>
                <span>Rule</span><br />
                <p className={classes.RuleName}>{rule.name}</p>
            </div>
            <div className={classes.WorkbookContainer}>
                <BobWorkbookModeButton
                    handleWorkbookMode={handleWorkbookMode}
                    workbookMode={workbookModeEnabled}
                />
            </div>
            <div
                className={classes.RefreshContainer}
                aria-hidden="true"
                role="button"
                tabIndex={0}
                onClick={refreshGrid}
            >
                <span className="material-icons-outlined">refresh</span>
            </div>
            <React.Fragment>
                <style>
                    { kendoGridInlineStyling }
                </style>
                <div ref={gridDivRef} className={classes.GridContainer}>
                    <div className={classes.Table}>
                        <div className={classes.TablePanel}>
                            <Grid
                                ref={gridRef}
                                className={classes.KendoGrid}
                                data={ruleDebuggerList.length > 0 ? orderBy(filterBy(ruleDebuggerList, dataState.filter), dataState.sort) : []}
                                {...dataState}
                                filterable={workbookModeEnabled}
                                sortable={{
                                    mode: 'multiple'
                                }}
                                onDataStateChange={onDataStateChange}
                                pageable={pageable}
                                reorderable
                                total={total}
                            >
                                {
                                    bobLoading.includes('fetchRuleDebuggerList') ?
                                        <GridNoRecords>
                                            Loading debugger information
                                        </GridNoRecords>
                                        :
                                        null
                                }
                                <Column
                                    field={'insertTimestamp'}
                                    title={dashboardContent.timeStamp}
                                    width="250px"
                                    cell={dateCell}
                                    filter={'date'}
                                />

                                <Column field="clientName" title="Client" width="250px" />
                                <Column field="siteName" title="Site" width="250px" />
                                <Column field="entityName" title="Target" width="250px" />
                                <Column field="notes" title={dashboardContent.errorMessage} width={ messageColumnWidth} />
                            </Grid>
                        </div>
                    </div>
                    {
                        bobLoading.includes('fetchRuleDebuggerList') ?
                            <BobLoadingMask />
                            :
                            null
                    }
                </div>
            </React.Fragment>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:    state.bob.activeNavCompany,
        bobLoading:          state.bob.bobLoading,
        ruleEndTimeStamp:    state.rules.ruleEndTimeStamp,
        ruleStartTimeStamp:  state.rules.ruleStartTimeStamp,
        workbookModeEnabled: state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...DashboardActions,
    ...ruleActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RuleDebugger));
